import type { ExposureNavigationEntry, ExposureState } from "./ExposureContext";

export function buildExposureNavigationStack(
  state: ExposureState,
): ExposureNavigationEntry[] {
  const stack: ExposureNavigationEntry[] = [{ name: "ExposureTypes" }];

  const selections = state.selectedExposures ?? [];
  if (selections.length > 0) {
    selections.forEach((exposure) => {
      if (exposure) {
        stack.push({ name: "ExposureDetails", params: { exposure } });
      }
    });
  }

  // Always add complete screen at the end
  stack.push({ name: "ExposureComplete" });

  return stack;
}
